import BaseHeading from '@tiptap/extension-heading';

export const Heading = BaseHeading.extend({
  addAttributes() {
    return {
      dataType: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute('data-type'),
        renderHTML: (attributes: Record<string, any>) => {
          return {
            'data-type': attributes.dataType,
          };
        },
      },
      level: {
        default: 1,
        rendered: false,
      },
    };
  },
  addInputRules() {
    return [];
  },
});
